/*global Modernizr, console */
/*jslint browser:true */

(function() {
  'use strict';

  var tables = document.querySelectorAll('table');
  if(tables) {
    tables.forEach((table) => {
      if(!table.parentNode.classList.contains('table-container')) {
        var table_wrapper = document.createElement('div');
        table_wrapper.classList.add('table-container');

        table_wrapper.innerHTML = `<div class="scroll-indicator">
  <svg class="icon arrow-left" viewBox="0 0 24 24"><use xlink:href="#scroll-right"></use></svg>
  <span>Scroll to see more</span>
  <svg class="icon" viewBox="0 0 24 24"><use xlink:href="#scroll-right"></use></svg>
</div>`;

        table.parentNode.insertBefore(table_wrapper, table);
        table_wrapper.appendChild(table);
      }
    });
  }

  var table_containers = document.querySelectorAll('.table-container');
  if(table_containers) {
    table_containers.forEach((table_container) => {
      check_table_overflow(table_container);

      window.addEventListener('resize', () => {
        check_table_overflow(table_container);
      });
    });
  }

  function check_table_overflow(table_container) {
    if(table_container.scrollWidth > table_container.offsetWidth) {
      table_container.classList.add('overflow');
    } else {
      table_container.classList.remove('overflow');
    }
  }
}());